import React from 'react';
import { useConnectionAlerts } from '@/hooks/useConnectionAlerts';
import { WifiOff, Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface ConnectionGuardProps {
  children: React.ReactNode;
}

export const ConnectionGuard: React.FC<ConnectionGuardProps> = ({ children }) => {
  const { whatsappDisconnected, loading } = useConnectionAlerts();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="w-full h-[calc(100vh-110px)] flex items-center justify-center bg-neutral-900">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-neutral-600 border-t-neutral-50 rounded-full animate-spin"></div>
          <p className="text-neutral-400 text-sm">Verificando conexão do WhatsApp...</p>
        </div>
      </div>
    );
  }

  if (whatsappDisconnected) {
    return (
      <div className="w-full h-[calc(100vh-110px)] flex items-center justify-center bg-neutral-900">
        <div className="max-w-md w-full mx-4">
          <div className="bg-neutral-800 border border-neutral-700 rounded-lg p-8 text-center">
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 bg-orange-500/10 border border-orange-500/20 rounded-full flex items-center justify-center">
                <WifiOff className="w-10 h-10 text-orange-500" />
              </div>
            </div>

            <h1 className="text-2xl font-bold text-neutral-50 mb-3">
              WhatsApp Desconectado
            </h1>

            <p className="text-neutral-400 mb-2">
              O chat não está disponível porque o WhatsApp não está conectado.
            </p>

            <p className="text-sm text-neutral-500 mb-8">
              Conecte sua instância do WhatsApp para acessar o chat e enviar mensagens.
            </p>

            <div className="flex flex-col gap-3">
              <button
                onClick={() => navigate('/settings')}
                className="w-full bg-orange-600 hover:bg-orange-500 text-white font-medium py-3 px-4 rounded-lg transition-colors flex items-center justify-center gap-2"
              >
                <Settings className="w-4 h-4" />
                Conectar WhatsApp
              </button>

              <button
                onClick={() => navigate('/')}
                className="w-full bg-transparent hover:bg-neutral-700/50 text-neutral-400 hover:text-neutral-50 font-medium py-3 px-4 rounded-lg transition-colors border border-neutral-700"
              >
                Voltar ao Dashboard
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
